import request from './request'

export const productView = (product,article)=>{
    // we get source url
    const url = window.location.href;
    // we get the fbc and fbp from the cookies
    let fbc = document.cookie.split('; ').find(row => row.startsWith('_fbc='));
    if(fbc){
        fbc = fbc.split('=')[1];
    }else{
        fbc='';
    }
    let fbp = document.cookie.split('; ').find(row => row.startsWith('_fbp='))
    if(fbp){
        fbp = fbp.split('=')[1];
    }else{
        fbp='';
    }
    // we get the fbclid from the url
    const fbclid = new URLSearchParams(window.location.search).get('fbclid');
    if(fbclid!== null){
        fbc = fbclid;
    }
    

    const payload = {
        event_name: 'ViewContent',
        event_source_url: url,
        content_ids: [article.sku],
        content_type: 'product',
        content_name: article.name ? product.name+' - '+article.name : product.name,
        fbc: fbc,
        fbp: fbp
    }
    return new Promise((resolve, reject) => {
        request.post(`event`, payload)
            .then((response) => {
                resolve(response)
            })
            .catch((error) => {
                reject(error)
            })
    })
}
export const addToWishlistFB = (product)=>{
    // we get source url
    const url = window.location.href;
    // we get the fbc and fbp from the cookies
    let fbc = document.cookie.split('; ').find(row => row.startsWith('_fbc='));
    if(fbc){
        fbc = fbc.split('=')[1];
    }else{
        fbc='';
    }
    let fbp = document.cookie.split('; ').find(row => row.startsWith('_fbp='))
    if(fbp){
        fbp = fbp.split('=')[1];
    }else{
        fbp='';
    }
    // we get the fbclid from the url
    const fbclid = new URLSearchParams(window.location.search).get('fbclid');
    if(fbclid!== null){
        fbc = fbclid;
    }

    const payload = {
        event_name: 'AddToWishlist',
        event_source_url: url,
        content_ids: [product.id],
        content_type: 'product_group',
        content_name: product.name,
        fbc: fbc,
        fbp: fbp
    }
    return new Promise((resolve, reject) => {
        request.post(`event`, payload)
            .then((response) => {
                resolve(response)
            })
            .catch((error) => {
                reject(error)
            })
    })
}
export const addToCartFB = (item)=>{
    // we get source url
    const url = window.location.href;
    // we get the fbc and fbp from the cookies
    let fbc = document.cookie.split('; ').find(row => row.startsWith('_fbc='));
    if(fbc){
        fbc = fbc.split('=')[1];
    }else{
        fbc='';
    }
    let fbp = document.cookie.split('; ').find(row => row.startsWith('_fbp='))
    if(fbp){
        fbp = fbp.split('=')[1];
    }else{
        fbp='';
    }
    // we get the fbclid from the url
    const fbclid = new URLSearchParams(window.location.search).get('fbclid');
    if(fbclid!== null){
        fbc = fbclid;
    }
    // numItems = sum of items quantity
    const numItems = item.quantity;
    const value = item.price

    const payload = {
        event_name: 'AddToCart',
        event_source_url: url,
        content_ids: [item.id],
        content_type: 'product',
        contents: [item],
        num_items: numItems,
        value: value,
        currency: 'EUR',
        fbc: fbc,
        fbp: fbp
    }
    return new Promise((resolve, reject) => {
        request.post(`event`, payload)
            .then((response) => {
                resolve(response)
            })
            .catch((error) => {
                reject(error)
            })
    })
}

export const searchView = (search)=>{
    // we get source url
    const url = window.location.href;
    // we get the fbc and fbp from the cookies
    let fbc = document.cookie.split('; ').find(row => row.startsWith('_fbc='));
    if(fbc){
        fbc = fbc.split('=')[1];
    }else{
        fbc='';
    }
    let fbp = document.cookie.split('; ').find(row => row.startsWith('_fbp='))
    if(fbp){
        fbp = fbp.split('=')[1];
    }else{
        fbp='';
    }
    // we get the fbclid from the url
    const fbclid = new URLSearchParams(window.location.search).get('fbclid');
    if(fbclid!== null){
        fbc = fbclid;
    }

    const payload = {
        event_name: 'Search',
        event_source_url: url,
        search_string: search,
        fbc: fbc,
        fbp: fbp
    }
    return new Promise((resolve, reject) => {
        request.post(`event`, payload)
            .then((response) => {
                resolve(response)
            })
            .catch((error) => {
                reject(error)
            })
    })
}

export const InitiateCheckoutFB = (items)=>{
    // we get source url
    const url = window.location.href;
    // we get the fbc and fbp from the cookies
    let fbc = document.cookie.split('; ').find(row => row.startsWith('_fbc='));
    if(fbc){
        fbc = fbc.split('=')[1];
    }else{
        fbc='';
    }
    let fbp = document.cookie.split('; ').find(row => row.startsWith('_fbp='))
    if(fbp){
        fbp = fbp.split('=')[1];
    }else{
        fbp='';
    }
    // we get the fbclid from the url
    const fbclid = new URLSearchParams(window.location.search).get('fbclid');
    if(fbclid!== null){
        fbc = fbclid;
    }
    // numItems = sum of items quantity
    const numItems = items.reduce((acc, item) => acc + parseInt(item.quantity), 0);
    const value = items.reduce((acc, item) => acc + parseFloat(item.price) * parseInt(item.quantity), 0);



    const payload = {
        event_name: 'InitiateCheckout',
        event_source_url: url,
        content_ids: items.map(item => item.id),
        content_type: 'product',
        contents: items,
        num_items: numItems,
        value: value,
        currency: 'EUR',
        fbc: fbc,
        fbp: fbp
    }
    return new Promise((resolve, reject) => {
        request.post(`event`, payload)
            .then((response) => {
                resolve(response)
            })
            .catch((error) => {
                reject(error)
            })
    })
}

export const AddPaymentInfoFB = (order,items)=>{
    // we get source url
    const url = window.location.href;
    // we get the fbc and fbp from the cookies
    let fbc = document.cookie.split('; ').find(row => row.startsWith('_fbc='));
    if(fbc){
        fbc = fbc.split('=')[1];
    }else{
        fbc='';
    }
    let fbp = document.cookie.split('; ').find(row => row.startsWith('_fbp='))
    if(fbp){
        fbp = fbp.split('=')[1];
    }else{
        fbp='';
    }
    // we get the fbclid from the url
    const fbclid = new URLSearchParams(window.location.search).get('fbclid');
    if(fbclid!== null){
        fbc = fbclid;
    }
    // numItems = sum of items quantity
    const numItems = items.reduce((acc, item) => acc + parseInt(item.quantity), 0);
    const value = parseFloat(order.total_ttc)
    const payload = {
        event_name: 'AddPaymentInfo',
        event_source_url: url,
        content_ids: items.map(item => item.id),
        content_type: 'product',
        contents: items,
        order_id: order.id,
        num_items: numItems,
        value: parseInt(order.total_ttc),
        currency: 'EUR',
        fbc: fbc,
        fbp: fbp
    }
    return new Promise((resolve, reject) => {
        request.post(`event`, payload)
            .then((response) => {
                resolve(response)
            })
            .catch((error) => {
                reject(error)
            })
    })
}

export const PurchaseFB = (order,items)=>{
    // we get source url
    const url = window.location.href;
    // we get the fbc and fbp from the cookies
    let fbc = document.cookie.split('; ').find(row => row.startsWith('_fbc='));
    if(fbc){
        fbc = fbc.split('=')[1];
    }else{
        fbc='';
    }
    let fbp = document.cookie.split('; ').find(row => row.startsWith('_fbp='))
    if(fbp){
        fbp = fbp.split('=')[1];
    }else{
        fbp='';
    }
    // we get the fbclid from the url
    const fbclid = new URLSearchParams(window.location.search).get('fbclid');
    if(fbclid!== null){
        fbc = fbclid;
    }
    // numItems = sum of items quantity
    const numItems = items.reduce((acc, item) => acc + parseInt(item.quantity), 0);
    const value = parseFloat(order.total_ttc)



    const payload = {
        event_name: 'Purchase',
        event_source_url: url,
        content_ids: items.map(item => item.id),
        content_type: 'product',
        contents: items,
        order_id: order.id,
        num_items: numItems,
        value: parseInt(order.total_ttc),
        currency: 'EUR',
        fbc: fbc,
        fbp: fbp
    }
    return new Promise((resolve, reject) => {
        request.post(`event`, payload)
            .then((response) => {
                resolve(response)
            })
            .catch((error) => {
                reject(error)
            })
    })
}